import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, InjectionToken, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { TokenInterceptorService } from './features/competition/registration/services/token.interceptor.service';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';

export interface AppConfig {
  userPoolId: string;
  userPoolClientId: string;
  profileUrl: string;
  competitionUrl: string;
  competitionId: string;
  socialLoginDomain: string;
  socialLoginRedirectSignIn: string[];
  socialLoginRedirectSignOut: string[];
}

const configValues: AppConfig = {
  userPoolId: environment.cognito.userPoolId,
  userPoolClientId: environment.cognito.userPoolClientId,
  profileUrl: environment.urls.profile,
  competitionUrl: environment.urls.competition,
  competitionId: environment.competitionId,
  socialLoginDomain: environment.cognito.socialLogin.domain,
  socialLoginRedirectSignIn: environment.cognito.socialLogin.redirectSignIn,
  socialLoginRedirectSignOut: environment.cognito.socialLogin.redirectSignOut,
};

export const APP_CONFIG = new InjectionToken<AppConfig>('APP_CONFIG');

export const appConfig: ApplicationConfig = {
  providers: [
    provideClientHydration(withEventReplay()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),

    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true
    },
    { provide: APP_CONFIG, useValue: configValues }
  ]
};
